export {
  KeyTakeawaysCard,
  type KeyTakeawaysCardProps,
} from "./KeyTakeawaysCard";

export { apiArticleToKeyTakeawaysCardProps } from "./apiArticleToKeyTakeawaysCardProps";
export { apiAnalystReportToKeyTakeawaysCardProps } from "./apiAnalystReportToKeyTakeawayCardProps";
